module.exports = __webpack_public_path__ + "static/media/reorder.19d7cf4a.jpg";